import { render, staticRenderFns } from "./reports-user-tags-inverse-graph.vue?vue&type=template&id=60179776"
import script from "./reports-user-tags-inverse-graph.vue?vue&type=script&lang=js"
export * from "./reports-user-tags-inverse-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports